[
  {
    "code": "AD",
    "label": {
      "en": "Andorra",
      "es": "Andorra"
    },
    "order": 1,
    "is_active": false,
    "metadata": {
      "alpha3": "AND",
      "numeric": "020",
      "phone_prefix": "+376",
      "flag": "🇦🇩",
      "region": "europe"
    }
  },
  {
    "code": "AE",
    "label": {
      "en": "United Arab Emirates",
      "es": "Emiratos Árabes Unidos"
    },
    "order": 2,
    "is_active": false,
    "metadata": {
      "alpha3": "ARE",
      "numeric": "784",
      "phone_prefix": "+971",
      "flag": "🇦🇪",
      "region": "asia"
    }
  },
  {
    "code": "AF",
    "label": {
      "en": "Afghanistan",
      "es": "Afganistán"
    },
    "order": 3,
    "is_active": false,
    "metadata": {
      "alpha3": "AFG",
      "numeric": "004",
      "phone_prefix": "+93",
      "flag": "🇦🇫",
      "region": "asia"
    }
  },
  {
    "code": "AG",
    "label": {
      "en": "Antigua and Barbuda",
      "es": "Antigua y Barbuda"
    },
    "order": 4,
    "is_active": false,
    "metadata": {
      "alpha3": "ATG",
      "numeric": "028",
      "phone_prefix": "+1-268",
      "flag": "🇦🇬",
      "region": "americas"
    }
  },
  {
    "code": "AL",
    "label": {
      "en": "Albania",
      "es": "Albania"
    },
    "order": 5,
    "is_active": false,
    "metadata": {
      "alpha3": "ALB",
      "numeric": "008",
      "phone_prefix": "+355",
      "flag": "🇦🇱",
      "region": "europe"
    }
  },
  {
    "code": "AM",
    "label": {
      "en": "Armenia",
      "es": "Armenia"
    },
    "order": 6,
    "is_active": false,
    "metadata": {
      "alpha3": "ARM",
      "numeric": "051",
      "phone_prefix": "+374",
      "flag": "🇦🇲",
      "region": "asia"
    }
  },
  {
    "code": "AO",
    "label": {
      "en": "Angola",
      "es": "Angola"
    },
    "order": 7,
    "is_active": false,
    "metadata": {
      "alpha3": "AGO",
      "numeric": "024",
      "phone_prefix": "+244",
      "flag": "🇦🇴",
      "region": "africa"
    }
  },
  {
    "code": "AR",
    "label": {
      "en": "Argentina",
      "es": "Argentina"
    },
    "order": 8,
    "is_active": false,
    "metadata": {
      "alpha3": "ARG",
      "numeric": "032",
      "phone_prefix": "+54",
      "flag": "🇦🇷",
      "region": "americas"
    }
  },
  {
    "code": "AT",
    "label": {
      "en": "Austria",
      "es": "Austria"
    },
    "order": 9,
    "is_active": false,
    "metadata": {
      "alpha3": "AUT",
      "numeric": "040",
      "phone_prefix": "+43",
      "flag": "🇦🇹",
      "region": "europe"
    }
  },
  {
    "code": "AU",
    "label": {
      "en": "Australia",
      "es": "Australia"
    },
    "order": 10,
    "is_active": false,
    "metadata": {
      "alpha3": "AUS",
      "numeric": "036",
      "phone_prefix": "+61",
      "flag": "🇦🇺",
      "region": "oceania"
    }
  },
  {
    "code": "AZ",
    "label": {
      "en": "Azerbaijan",
      "es": "Azerbaiyán"
    },
    "order": 11,
    "is_active": false,
    "metadata": {
      "alpha3": "AZE",
      "numeric": "031",
      "phone_prefix": "+994",
      "flag": "🇦🇿",
      "region": "asia"
    }
  },
  {
    "code": "BA",
    "label": {
      "en": "Bosnia and Herzegovina",
      "es": "Bosnia y Herzegovina"
    },
    "order": 12,
    "is_active": false,
    "metadata": {
      "alpha3": "BIH",
      "numeric": "070",
      "phone_prefix": "+387",
      "flag": "🇧🇦",
      "region": "europe"
    }
  },
  {
    "code": "BB",
    "label": {
      "en": "Barbados",
      "es": "Barbados"
    },
    "order": 13,
    "is_active": false,
    "metadata": {
      "alpha3": "BRB",
      "numeric": "052",
      "phone_prefix": "+1-246",
      "flag": "🇧🇧",
      "region": "americas"
    }
  },
  {
    "code": "BD",
    "label": {
      "en": "Bangladesh",
      "es": "Bangladés"
    },
    "order": 14,
    "is_active": false,
    "metadata": {
      "alpha3": "BGD",
      "numeric": "050",
      "phone_prefix": "+880",
      "flag": "🇧🇩",
      "region": "asia"
    }
  },
  {
    "code": "BE",
    "label": {
      "en": "Belgium",
      "es": "Bélgica"
    },
    "order": 15,
    "is_active": false,
    "metadata": {
      "alpha3": "BEL",
      "numeric": "056",
      "phone_prefix": "+32",
      "flag": "🇧🇪",
      "region": "europe"
    }
  },
  {
    "code": "BF",
    "label": {
      "en": "Burkina Faso",
      "es": "Burkina Faso"
    },
    "order": 16,
    "is_active": false,
    "metadata": {
      "alpha3": "BFA",
      "numeric": "854",
      "phone_prefix": "+226",
      "flag": "🇧🇫",
      "region": "africa"
    }
  },
  {
    "code": "BG",
    "label": {
      "en": "Bulgaria",
      "es": "Bulgaria"
    },
    "order": 17,
    "is_active": false,
    "metadata": {
      "alpha3": "BGR",
      "numeric": "100",
      "phone_prefix": "+359",
      "flag": "🇧🇬",
      "region": "europe"
    }
  },
  {
    "code": "BH",
    "label": {
      "en": "Bahrain",
      "es": "Baréin"
    },
    "order": 18,
    "is_active": false,
    "metadata": {
      "alpha3": "BHR",
      "numeric": "048",
      "phone_prefix": "+973",
      "flag": "🇧🇭",
      "region": "asia"
    }
  },
  {
    "code": "BI",
    "label": {
      "en": "Burundi",
      "es": "Burundi"
    },
    "order": 19,
    "is_active": false,
    "metadata": {
      "alpha3": "BDI",
      "numeric": "108",
      "phone_prefix": "+257",
      "flag": "🇧🇮",
      "region": "africa"
    }
  },
  {
    "code": "BJ",
    "label": {
      "en": "Benin",
      "es": "Benín"
    },
    "order": 20,
    "is_active": false,
    "metadata": {
      "alpha3": "BEN",
      "numeric": "204",
      "phone_prefix": "+229",
      "flag": "🇧🇯",
      "region": "africa"
    }
  },
  {
    "code": "BN",
    "label": {
      "en": "Brunei",
      "es": "Brunéi"
    },
    "order": 21,
    "is_active": false,
    "metadata": {
      "alpha3": "BRN",
      "numeric": "096",
      "phone_prefix": "+673",
      "flag": "🇧🇳",
      "region": "asia"
    }
  },
  {
    "code": "BO",
    "label": {
      "en": "Bolivia",
      "es": "Bolivia"
    },
    "order": 22,
    "is_active": false,
    "metadata": {
      "alpha3": "BOL",
      "numeric": "068",
      "phone_prefix": "+591",
      "flag": "🇧🇴",
      "region": "americas"
    }
  },
  {
    "code": "BR",
    "label": {
      "en": "Brazil",
      "es": "Brasil"
    },
    "order": 23,
    "is_active": false,
    "metadata": {
      "alpha3": "BRA",
      "numeric": "076",
      "phone_prefix": "+55",
      "flag": "🇧🇷",
      "region": "americas"
    }
  },
  {
    "code": "BS",
    "label": {
      "en": "Bahamas",
      "es": "Bahamas"
    },
    "order": 24,
    "is_active": false,
    "metadata": {
      "alpha3": "BHS",
      "numeric": "044",
      "phone_prefix": "+1-242",
      "flag": "🇧🇸",
      "region": "americas"
    }
  },
  {
    "code": "BT",
    "label": {
      "en": "Bhutan",
      "es": "Bután"
    },
    "order": 25,
    "is_active": false,
    "metadata": {
      "alpha3": "BTN",
      "numeric": "064",
      "phone_prefix": "+975",
      "flag": "🇧🇹",
      "region": "asia"
    }
  },
  {
    "code": "BW",
    "label": {
      "en": "Botswana",
      "es": "Botsuana"
    },
    "order": 26,
    "is_active": false,
    "metadata": {
      "alpha3": "BWA",
      "numeric": "072",
      "phone_prefix": "+267",
      "flag": "🇧🇼",
      "region": "africa"
    }
  },
  {
    "code": "BY",
    "label": {
      "en": "Belarus",
      "es": "Bielorrusia"
    },
    "order": 27,
    "is_active": false,
    "metadata": {
      "alpha3": "BLR",
      "numeric": "112",
      "phone_prefix": "+375",
      "flag": "🇧🇾",
      "region": "europe"
    }
  },
  {
    "code": "BZ",
    "label": {
      "en": "Belize",
      "es": "Belice"
    },
    "order": 28,
    "is_active": false,
    "metadata": {
      "alpha3": "BLZ",
      "numeric": "084",
      "phone_prefix": "+501",
      "flag": "🇧🇿",
      "region": "americas"
    }
  },
  {
    "code": "CA",
    "label": {
      "en": "Canada",
      "es": "Canadá"
    },
    "order": 29,
    "is_active": false,
    "metadata": {
      "alpha3": "CAN",
      "numeric": "124",
      "phone_prefix": "+1",
      "flag": "🇨🇦",
      "region": "americas"
    }
  },
  {
    "code": "CD",
    "label": {
      "en": "Democratic Republic of the Congo",
      "es": "República Democrática del Congo"
    },
    "order": 30,
    "is_active": false,
    "metadata": {
      "alpha3": "COD",
      "numeric": "180",
      "phone_prefix": "+243",
      "flag": "🇨🇩",
      "region": "africa"
    }
  },
  {
    "code": "CF",
    "label": {
      "en": "Central African Republic",
      "es": "República Centroafricana"
    },
    "order": 31,
    "is_active": false,
    "metadata": {
      "alpha3": "CAF",
      "numeric": "140",
      "phone_prefix": "+236",
      "flag": "🇨🇫",
      "region": "africa"
    }
  },
  {
    "code": "CG",
    "label": {
      "en": "Republic of the Congo",
      "es": "República del Congo"
    },
    "order": 32,
    "is_active": false,
    "metadata": {
      "alpha3": "COG",
      "numeric": "178",
      "phone_prefix": "+242",
      "flag": "🇨🇬",
      "region": "africa"
    }
  },
  {
    "code": "CH",
    "label": {
      "en": "Switzerland",
      "es": "Suiza"
    },
    "order": 33,
    "is_active": false,
    "metadata": {
      "alpha3": "CHE",
      "numeric": "756",
      "phone_prefix": "+41",
      "flag": "🇨🇭",
      "region": "europe"
    }
  },
  {
    "code": "CI",
    "label": {
      "en": "Ivory Coast",
      "es": "Costa de Marfil"
    },
    "order": 34,
    "is_active": false,
    "metadata": {
      "alpha3": "CIV",
      "numeric": "384",
      "phone_prefix": "+225",
      "flag": "🇨🇮",
      "region": "africa"
    }
  },
  {
    "code": "CL",
    "label": {
      "en": "Chile",
      "es": "Chile"
    },
    "order": 35,
    "is_active": false,
    "metadata": {
      "alpha3": "CHL",
      "numeric": "152",
      "phone_prefix": "+56",
      "flag": "🇨🇱",
      "region": "americas"
    }
  },
  {
    "code": "CM",
    "label": {
      "en": "Cameroon",
      "es": "Camerún"
    },
    "order": 36,
    "is_active": false,
    "metadata": {
      "alpha3": "CMR",
      "numeric": "120",
      "phone_prefix": "+237",
      "flag": "🇨🇲",
      "region": "africa"
    }
  },
  {
    "code": "CN",
    "label": {
      "en": "China",
      "es": "China"
    },
    "order": 37,
    "is_active": false,
    "metadata": {
      "alpha3": "CHN",
      "numeric": "156",
      "phone_prefix": "+86",
      "flag": "🇨🇳",
      "region": "asia"
    }
  },
  {
    "code": "CO",
    "label": {
      "en": "Colombia",
      "es": "Colombia"
    },
    "order": 38,
    "is_active": false,
    "metadata": {
      "alpha3": "COL",
      "numeric": "170",
      "phone_prefix": "+57",
      "flag": "🇨🇴",
      "region": "americas"
    }
  },
  {
    "code": "CR",
    "label": {
      "en": "Costa Rica",
      "es": "Costa Rica"
    },
    "order": 39,
    "is_active": false,
    "metadata": {
      "alpha3": "CRI",
      "numeric": "188",
      "phone_prefix": "+506",
      "flag": "🇨🇷",
      "region": "americas"
    }
  },
  {
    "code": "CU",
    "label": {
      "en": "Cuba",
      "es": "Cuba"
    },
    "order": 40,
    "is_active": false,
    "metadata": {
      "alpha3": "CUB",
      "numeric": "192",
      "phone_prefix": "+53",
      "flag": "🇨🇺",
      "region": "americas"
    }
  },
  {
    "code": "CV",
    "label": {
      "en": "Cape Verde",
      "es": "Cabo Verde"
    },
    "order": 41,
    "is_active": false,
    "metadata": {
      "alpha3": "CPV",
      "numeric": "132",
      "phone_prefix": "+238",
      "flag": "🇨🇻",
      "region": "africa"
    }
  },
  {
    "code": "CY",
    "label": {
      "en": "Cyprus",
      "es": "Chipre"
    },
    "order": 42,
    "is_active": false,
    "metadata": {
      "alpha3": "CYP",
      "numeric": "196",
      "phone_prefix": "+357",
      "flag": "🇨🇾",
      "region": "europe"
    }
  },
  {
    "code": "CZ",
    "label": {
      "en": "Czech Republic",
      "es": "República Checa"
    },
    "order": 43,
    "is_active": false,
    "metadata": {
      "alpha3": "CZE",
      "numeric": "203",
      "phone_prefix": "+420",
      "flag": "🇨🇿",
      "region": "europe"
    }
  },
  {
    "code": "DE",
    "label": {
      "en": "Germany",
      "es": "Alemania"
    },
    "order": 44,
    "is_active": false,
    "metadata": {
      "alpha3": "DEU",
      "numeric": "276",
      "phone_prefix": "+49",
      "flag": "🇩🇪",
      "region": "europe"
    }
  },
  {
    "code": "DJ",
    "label": {
      "en": "Djibouti",
      "es": "Yibuti"
    },
    "order": 45,
    "is_active": false,
    "metadata": {
      "alpha3": "DJI",
      "numeric": "262",
      "phone_prefix": "+253",
      "flag": "🇩🇯",
      "region": "africa"
    }
  },
  {
    "code": "DK",
    "label": {
      "en": "Denmark",
      "es": "Dinamarca"
    },
    "order": 46,
    "is_active": false,
    "metadata": {
      "alpha3": "DNK",
      "numeric": "208",
      "phone_prefix": "+45",
      "flag": "🇩🇰",
      "region": "europe"
    }
  },
  {
    "code": "DM",
    "label": {
      "en": "Dominica",
      "es": "Dominica"
    },
    "order": 47,
    "is_active": false,
    "metadata": {
      "alpha3": "DMA",
      "numeric": "212",
      "phone_prefix": "+1-767",
      "flag": "🇩🇲",
      "region": "americas"
    }
  },
  {
    "code": "DO",
    "label": {
      "en": "Dominican Republic",
      "es": "República Dominicana"
    },
    "order": 48,
    "is_active": false,
    "metadata": {
      "alpha3": "DOM",
      "numeric": "214",
      "phone_prefix": "+1-809",
      "flag": "🇩🇴",
      "region": "americas"
    }
  },
  {
    "code": "DZ",
    "label": {
      "en": "Algeria",
      "es": "Argelia"
    },
    "order": 49,
    "is_active": false,
    "metadata": {
      "alpha3": "DZA",
      "numeric": "012",
      "phone_prefix": "+213",
      "flag": "🇩🇿",
      "region": "africa"
    }
  },
  {
    "code": "EC",
    "label": {
      "en": "Ecuador",
      "es": "Ecuador"
    },
    "order": 50,
    "is_active": false,
    "metadata": {
      "alpha3": "ECU",
      "numeric": "218",
      "phone_prefix": "+593",
      "flag": "🇪🇨",
      "region": "americas"
    }
  },
  {
    "code": "EE",
    "label": {
      "en": "Estonia",
      "es": "Estonia"
    },
    "order": 51,
    "is_active": false,
    "metadata": {
      "alpha3": "EST",
      "numeric": "233",
      "phone_prefix": "+372",
      "flag": "🇪🇪",
      "region": "europe"
    }
  },
  {
    "code": "EG",
    "label": {
      "en": "Egypt",
      "es": "Egipto"
    },
    "order": 52,
    "is_active": false,
    "metadata": {
      "alpha3": "EGY",
      "numeric": "818",
      "phone_prefix": "+20",
      "flag": "🇪🇬",
      "region": "africa"
    }
  },
  {
    "code": "ER",
    "label": {
      "en": "Eritrea",
      "es": "Eritrea"
    },
    "order": 53,
    "is_active": false,
    "metadata": {
      "alpha3": "ERI",
      "numeric": "232",
      "phone_prefix": "+291",
      "flag": "🇪🇷",
      "region": "africa"
    }
  },
  {
    "code": "ES",
    "label": {
      "en": "Spain",
      "es": "España"
    },
    "order": 54,
    "is_active": true,
    "metadata": {
      "alpha3": "ESP",
      "numeric": "724",
      "phone_prefix": "+34",
      "flag": "🇪🇸",
      "region": "europe"
    }
  },
  {
    "code": "ET",
    "label": {
      "en": "Ethiopia",
      "es": "Etiopía"
    },
    "order": 55,
    "is_active": false,
    "metadata": {
      "alpha3": "ETH",
      "numeric": "231",
      "phone_prefix": "+251",
      "flag": "🇪🇹",
      "region": "africa"
    }
  },
  {
    "code": "FI",
    "label": {
      "en": "Finland",
      "es": "Finlandia"
    },
    "order": 56,
    "is_active": false,
    "metadata": {
      "alpha3": "FIN",
      "numeric": "246",
      "phone_prefix": "+358",
      "flag": "🇫🇮",
      "region": "europe"
    }
  },
  {
    "code": "FJ",
    "label": {
      "en": "Fiji",
      "es": "Fiyi"
    },
    "order": 57,
    "is_active": false,
    "metadata": {
      "alpha3": "FJI",
      "numeric": "242",
      "phone_prefix": "+679",
      "flag": "🇫🇯",
      "region": "oceania"
    }
  },
  {
    "code": "FR",
    "label": {
      "en": "France",
      "es": "Francia"
    },
    "order": 58,
    "is_active": false,
    "metadata": {
      "alpha3": "FRA",
      "numeric": "250",
      "phone_prefix": "+33",
      "flag": "🇫🇷",
      "region": "europe"
    }
  },
  {
    "code": "GA",
    "label": {
      "en": "Gabon",
      "es": "Gabón"
    },
    "order": 59,
    "is_active": false,
    "metadata": {
      "alpha3": "GAB",
      "numeric": "266",
      "phone_prefix": "+241",
      "flag": "🇬🇦",
      "region": "africa"
    }
  },
  {
    "code": "GB",
    "label": {
      "en": "United Kingdom",
      "es": "Reino Unido"
    },
    "order": 60,
    "is_active": false,
    "metadata": {
      "alpha3": "GBR",
      "numeric": "826",
      "phone_prefix": "+44",
      "flag": "🇬🇧",
      "region": "europe"
    }
  },
  {
    "code": "GD",
    "label": {
      "en": "Grenada",
      "es": "Granada"
    },
    "order": 61,
    "is_active": false,
    "metadata": {
      "alpha3": "GRD",
      "numeric": "308",
      "phone_prefix": "+1-473",
      "flag": "🇬🇩",
      "region": "americas"
    }
  },
  {
    "code": "GE",
    "label": {
      "en": "Georgia",
      "es": "Georgia"
    },
    "order": 62,
    "is_active": false,
    "metadata": {
      "alpha3": "GEO",
      "numeric": "268",
      "phone_prefix": "+995",
      "flag": "🇬🇪",
      "region": "asia"
    }
  },
  {
    "code": "GH",
    "label": {
      "en": "Ghana",
      "es": "Ghana"
    },
    "order": 63,
    "is_active": false,
    "metadata": {
      "alpha3": "GHA",
      "numeric": "288",
      "phone_prefix": "+233",
      "flag": "🇬🇭",
      "region": "africa"
    }
  },
  {
    "code": "GM",
    "label": {
      "en": "Gambia",
      "es": "Gambia"
    },
    "order": 64,
    "is_active": false,
    "metadata": {
      "alpha3": "GMB",
      "numeric": "270",
      "phone_prefix": "+220",
      "flag": "🇬🇲",
      "region": "africa"
    }
  },
  {
    "code": "GN",
    "label": {
      "en": "Guinea",
      "es": "Guinea"
    },
    "order": 65,
    "is_active": false,
    "metadata": {
      "alpha3": "GIN",
      "numeric": "324",
      "phone_prefix": "+224",
      "flag": "🇬🇳",
      "region": "africa"
    }
  },
  {
    "code": "GQ",
    "label": {
      "en": "Equatorial Guinea",
      "es": "Guinea Ecuatorial"
    },
    "order": 66,
    "is_active": false,
    "metadata": {
      "alpha3": "GNQ",
      "numeric": "226",
      "phone_prefix": "+240",
      "flag": "🇬🇶",
      "region": "africa"
    }
  },
  {
    "code": "GR",
    "label": {
      "en": "Greece",
      "es": "Grecia"
    },
    "order": 67,
    "is_active": false,
    "metadata": {
      "alpha3": "GRC",
      "numeric": "300",
      "phone_prefix": "+30",
      "flag": "🇬🇷",
      "region": "europe"
    }
  },
  {
    "code": "GT",
    "label": {
      "en": "Guatemala",
      "es": "Guatemala"
    },
    "order": 68,
    "is_active": false,
    "metadata": {
      "alpha3": "GTM",
      "numeric": "320",
      "phone_prefix": "+502",
      "flag": "🇬🇹",
      "region": "americas"
    }
  },
  {
    "code": "GW",
    "label": {
      "en": "Guinea-Bissau",
      "es": "Guinea-Bisáu"
    },
    "order": 69,
    "is_active": false,
    "metadata": {
      "alpha3": "GNB",
      "numeric": "624",
      "phone_prefix": "+245",
      "flag": "🇬🇼",
      "region": "africa"
    }
  },
  {
    "code": "GY",
    "label": {
      "en": "Guyana",
      "es": "Guyana"
    },
    "order": 70,
    "is_active": false,
    "metadata": {
      "alpha3": "GUY",
      "numeric": "328",
      "phone_prefix": "+592",
      "flag": "🇬🇾",
      "region": "americas"
    }
  },
  {
    "code": "HN",
    "label": {
      "en": "Honduras",
      "es": "Honduras"
    },
    "order": 71,
    "is_active": false,
    "metadata": {
      "alpha3": "HND",
      "numeric": "340",
      "phone_prefix": "+504",
      "flag": "🇭🇳",
      "region": "americas"
    }
  },
  {
    "code": "HR",
    "label": {
      "en": "Croatia",
      "es": "Croacia"
    },
    "order": 72,
    "is_active": false,
    "metadata": {
      "alpha3": "HRV",
      "numeric": "191",
      "phone_prefix": "+385",
      "flag": "🇭🇷",
      "region": "europe"
    }
  },
  {
    "code": "HT",
    "label": {
      "en": "Haiti",
      "es": "Haití"
    },
    "order": 73,
    "is_active": false,
    "metadata": {
      "alpha3": "HTI",
      "numeric": "332",
      "phone_prefix": "+509",
      "flag": "🇭🇹",
      "region": "americas"
    }
  },
  {
    "code": "HU",
    "label": {
      "en": "Hungary",
      "es": "Hungría"
    },
    "order": 74,
    "is_active": false,
    "metadata": {
      "alpha3": "HUN",
      "numeric": "348",
      "phone_prefix": "+36",
      "flag": "🇭🇺",
      "region": "europe"
    }
  },
  {
    "code": "ID",
    "label": {
      "en": "Indonesia",
      "es": "Indonesia"
    },
    "order": 75,
    "is_active": false,
    "metadata": {
      "alpha3": "IDN",
      "numeric": "360",
      "phone_prefix": "+62",
      "flag": "🇮🇩",
      "region": "asia"
    }
  },
  {
    "code": "IE",
    "label": {
      "en": "Ireland",
      "es": "Irlanda"
    },
    "order": 76,
    "is_active": false,
    "metadata": {
      "alpha3": "IRL",
      "numeric": "372",
      "phone_prefix": "+353",
      "flag": "🇮🇪",
      "region": "europe"
    }
  },
  {
    "code": "IL",
    "label": {
      "en": "Israel",
      "es": "Israel"
    },
    "order": 77,
    "is_active": false,
    "metadata": {
      "alpha3": "ISR",
      "numeric": "376",
      "phone_prefix": "+972",
      "flag": "🇮🇱",
      "region": "asia"
    }
  },
  {
    "code": "IN",
    "label": {
      "en": "India",
      "es": "India"
    },
    "order": 78,
    "is_active": false,
    "metadata": {
      "alpha3": "IND",
      "numeric": "356",
      "phone_prefix": "+91",
      "flag": "🇮🇳",
      "region": "asia"
    }
  },
  {
    "code": "IQ",
    "label": {
      "en": "Iraq",
      "es": "Irak"
    },
    "order": 79,
    "is_active": false,
    "metadata": {
      "alpha3": "IRQ",
      "numeric": "368",
      "phone_prefix": "+964",
      "flag": "🇮🇶",
      "region": "asia"
    }
  },
  {
    "code": "IR",
    "label": {
      "en": "Iran",
      "es": "Irán"
    },
    "order": 80,
    "is_active": false,
    "metadata": {
      "alpha3": "IRN",
      "numeric": "364",
      "phone_prefix": "+98",
      "flag": "🇮🇷",
      "region": "asia"
    }
  },
  {
    "code": "IS",
    "label": {
      "en": "Iceland",
      "es": "Islandia"
    },
    "order": 81,
    "is_active": false,
    "metadata": {
      "alpha3": "ISL",
      "numeric": "352",
      "phone_prefix": "+354",
      "flag": "🇮🇸",
      "region": "europe"
    }
  },
  {
    "code": "IT",
    "label": {
      "en": "Italy",
      "es": "Italia"
    },
    "order": 82,
    "is_active": false,
    "metadata": {
      "alpha3": "ITA",
      "numeric": "380",
      "phone_prefix": "+39",
      "flag": "🇮🇹",
      "region": "europe"
    }
  },
  {
    "code": "JM",
    "label": {
      "en": "Jamaica",
      "es": "Jamaica"
    },
    "order": 83,
    "is_active": false,
    "metadata": {
      "alpha3": "JAM",
      "numeric": "388",
      "phone_prefix": "+1-876",
      "flag": "🇯🇲",
      "region": "americas"
    }
  },
  {
    "code": "JO",
    "label": {
      "en": "Jordan",
      "es": "Jordania"
    },
    "order": 84,
    "is_active": false,
    "metadata": {
      "alpha3": "JOR",
      "numeric": "400",
      "phone_prefix": "+962",
      "flag": "🇯🇴",
      "region": "asia"
    }
  },
  {
    "code": "JP",
    "label": {
      "en": "Japan",
      "es": "Japón"
    },
    "order": 85,
    "is_active": false,
    "metadata": {
      "alpha3": "JPN",
      "numeric": "392",
      "phone_prefix": "+81",
      "flag": "🇯🇵",
      "region": "asia"
    }
  },
  {
    "code": "KE",
    "label": {
      "en": "Kenya",
      "es": "Kenia"
    },
    "order": 86,
    "is_active": false,
    "metadata": {
      "alpha3": "KEN",
      "numeric": "404",
      "phone_prefix": "+254",
      "flag": "🇰🇪",
      "region": "africa"
    }
  },
  {
    "code": "KG",
    "label": {
      "en": "Kyrgyzstan",
      "es": "Kirguistán"
    },
    "order": 87,
    "is_active": false,
    "metadata": {
      "alpha3": "KGZ",
      "numeric": "417",
      "phone_prefix": "+996",
      "flag": "🇰🇬",
      "region": "asia"
    }
  },
  {
    "code": "KH",
    "label": {
      "en": "Cambodia",
      "es": "Camboya"
    },
    "order": 88,
    "is_active": false,
    "metadata": {
      "alpha3": "KHM",
      "numeric": "116",
      "phone_prefix": "+855",
      "flag": "🇰🇭",
      "region": "asia"
    }
  },
  {
    "code": "KI",
    "label": {
      "en": "Kiribati",
      "es": "Kiribati"
    },
    "order": 89,
    "is_active": false,
    "metadata": {
      "alpha3": "KIR",
      "numeric": "296",
      "phone_prefix": "+686",
      "flag": "🇰🇮",
      "region": "oceania"
    }
  },
  {
    "code": "KM",
    "label": {
      "en": "Comoros",
      "es": "Comoras"
    },
    "order": 90,
    "is_active": false,
    "metadata": {
      "alpha3": "COM",
      "numeric": "174",
      "phone_prefix": "+269",
      "flag": "🇰🇲",
      "region": "africa"
    }
  },
  {
    "code": "KN",
    "label": {
      "en": "Saint Kitts and Nevis",
      "es": "San Cristóbal y Nieves"
    },
    "order": 91,
    "is_active": false,
    "metadata": {
      "alpha3": "KNA",
      "numeric": "659",
      "phone_prefix": "+1-869",
      "flag": "🇰🇳",
      "region": "americas"
    }
  },
  {
    "code": "KP",
    "label": {
      "en": "North Korea",
      "es": "Corea del Norte"
    },
    "order": 92,
    "is_active": false,
    "metadata": {
      "alpha3": "PRK",
      "numeric": "408",
      "phone_prefix": "+850",
      "flag": "🇰🇵",
      "region": "asia"
    }
  },
  {
    "code": "KR",
    "label": {
      "en": "South Korea",
      "es": "Corea del Sur"
    },
    "order": 93,
    "is_active": false,
    "metadata": {
      "alpha3": "KOR",
      "numeric": "410",
      "phone_prefix": "+82",
      "flag": "🇰🇷",
      "region": "asia"
    }
  },
  {
    "code": "KW",
    "label": {
      "en": "Kuwait",
      "es": "Kuwait"
    },
    "order": 94,
    "is_active": false,
    "metadata": {
      "alpha3": "KWT",
      "numeric": "414",
      "phone_prefix": "+965",
      "flag": "🇰🇼",
      "region": "asia"
    }
  },
  {
    "code": "KZ",
    "label": {
      "en": "Kazakhstan",
      "es": "Kazajistán"
    },
    "order": 95,
    "is_active": false,
    "metadata": {
      "alpha3": "KAZ",
      "numeric": "398",
      "phone_prefix": "+7",
      "flag": "🇰🇿",
      "region": "asia"
    }
  },
  {
    "code": "LA",
    "label": {
      "en": "Laos",
      "es": "Laos"
    },
    "order": 96,
    "is_active": false,
    "metadata": {
      "alpha3": "LAO",
      "numeric": "418",
      "phone_prefix": "+856",
      "flag": "🇱🇦",
      "region": "asia"
    }
  },
  {
    "code": "LB",
    "label": {
      "en": "Lebanon",
      "es": "Líbano"
    },
    "order": 97,
    "is_active": false,
    "metadata": {
      "alpha3": "LBN",
      "numeric": "422",
      "phone_prefix": "+961",
      "flag": "🇱🇧",
      "region": "asia"
    }
  },
  {
    "code": "LC",
    "label": {
      "en": "Saint Lucia",
      "es": "Santa Lucía"
    },
    "order": 98,
    "is_active": false,
    "metadata": {
      "alpha3": "LCA",
      "numeric": "662",
      "phone_prefix": "+1-758",
      "flag": "🇱🇨",
      "region": "americas"
    }
  },
  {
    "code": "LI",
    "label": {
      "en": "Liechtenstein",
      "es": "Liechtenstein"
    },
    "order": 99,
    "is_active": false,
    "metadata": {
      "alpha3": "LIE",
      "numeric": "438",
      "phone_prefix": "+423",
      "flag": "🇱🇮",
      "region": "europe"
    }
  },
  {
    "code": "LK",
    "label": {
      "en": "Sri Lanka",
      "es": "Sri Lanka"
    },
    "order": 100,
    "is_active": false,
    "metadata": {
      "alpha3": "LKA",
      "numeric": "144",
      "phone_prefix": "+94",
      "flag": "🇱🇰",
      "region": "asia"
    }
  },
  {
    "code": "LR",
    "label": {
      "en": "Liberia",
      "es": "Liberia"
    },
    "order": 101,
    "is_active": false,
    "metadata": {
      "alpha3": "LBR",
      "numeric": "430",
      "phone_prefix": "+231",
      "flag": "🇱🇷",
      "region": "africa"
    }
  },
  {
    "code": "LS",
    "label": {
      "en": "Lesotho",
      "es": "Lesoto"
    },
    "order": 102,
    "is_active": false,
    "metadata": {
      "alpha3": "LSO",
      "numeric": "426",
      "phone_prefix": "+266",
      "flag": "🇱🇸",
      "region": "africa"
    }
  },
  {
    "code": "LT",
    "label": {
      "en": "Lithuania",
      "es": "Lituania"
    },
    "order": 103,
    "is_active": false,
    "metadata": {
      "alpha3": "LTU",
      "numeric": "440",
      "phone_prefix": "+370",
      "flag": "🇱🇹",
      "region": "europe"
    }
  },
  {
    "code": "LU",
    "label": {
      "en": "Luxembourg",
      "es": "Luxemburgo"
    },
    "order": 104,
    "is_active": false,
    "metadata": {
      "alpha3": "LUX",
      "numeric": "442",
      "phone_prefix": "+352",
      "flag": "🇱🇺",
      "region": "europe"
    }
  },
  {
    "code": "LV",
    "label": {
      "en": "Latvia",
      "es": "Letonia"
    },
    "order": 105,
    "is_active": false,
    "metadata": {
      "alpha3": "LVA",
      "numeric": "428",
      "phone_prefix": "+371",
      "flag": "🇱🇻",
      "region": "europe"
    }
  },
  {
    "code": "LY",
    "label": {
      "en": "Libya",
      "es": "Libia"
    },
    "order": 106,
    "is_active": false,
    "metadata": {
      "alpha3": "LBY",
      "numeric": "434",
      "phone_prefix": "+218",
      "flag": "🇱🇾",
      "region": "africa"
    }
  },
  {
    "code": "MA",
    "label": {
      "en": "Morocco",
      "es": "Marruecos"
    },
    "order": 107,
    "is_active": false,
    "metadata": {
      "alpha3": "MAR",
      "numeric": "504",
      "phone_prefix": "+212",
      "flag": "🇲🇦",
      "region": "africa"
    }
  },
  {
    "code": "MC",
    "label": {
      "en": "Monaco",
      "es": "Mónaco"
    },
    "order": 108,
    "is_active": false,
    "metadata": {
      "alpha3": "MCO",
      "numeric": "492",
      "phone_prefix": "+377",
      "flag": "🇲🇨",
      "region": "europe"
    }
  },
  {
    "code": "MD",
    "label": {
      "en": "Moldova",
      "es": "Moldavia"
    },
    "order": 109,
    "is_active": false,
    "metadata": {
      "alpha3": "MDA",
      "numeric": "498",
      "phone_prefix": "+373",
      "flag": "🇲🇩",
      "region": "europe"
    }
  },
  {
    "code": "ME",
    "label": {
      "en": "Montenegro",
      "es": "Montenegro"
    },
    "order": 110,
    "is_active": false,
    "metadata": {
      "alpha3": "MNE",
      "numeric": "499",
      "phone_prefix": "+382",
      "flag": "🇲🇪",
      "region": "europe"
    }
  },
  {
    "code": "MG",
    "label": {
      "en": "Madagascar",
      "es": "Madagascar"
    },
    "order": 111,
    "is_active": false,
    "metadata": {
      "alpha3": "MDG",
      "numeric": "450",
      "phone_prefix": "+261",
      "flag": "🇲🇬",
      "region": "africa"
    }
  },
  {
    "code": "MH",
    "label": {
      "en": "Marshall Islands",
      "es": "Islas Marshall"
    },
    "order": 112,
    "is_active": false,
    "metadata": {
      "alpha3": "MHL",
      "numeric": "584",
      "phone_prefix": "+692",
      "flag": "🇲🇭",
      "region": "oceania"
    }
  },
  {
    "code": "MK",
    "label": {
      "en": "North Macedonia",
      "es": "Macedonia del Norte"
    },
    "order": 113,
    "is_active": false,
    "metadata": {
      "alpha3": "MKD",
      "numeric": "807",
      "phone_prefix": "+389",
      "flag": "🇲🇰",
      "region": "europe"
    }
  },
  {
    "code": "ML",
    "label": {
      "en": "Mali",
      "es": "Malí"
    },
    "order": 114,
    "is_active": false,
    "metadata": {
      "alpha3": "MLI",
      "numeric": "466",
      "phone_prefix": "+223",
      "flag": "🇲🇱",
      "region": "africa"
    }
  },
  {
    "code": "MM",
    "label": {
      "en": "Myanmar",
      "es": "Myanmar"
    },
    "order": 115,
    "is_active": false,
    "metadata": {
      "alpha3": "MMR",
      "numeric": "104",
      "phone_prefix": "+95",
      "flag": "🇲🇲",
      "region": "asia"
    }
  },
  {
    "code": "MN",
    "label": {
      "en": "Mongolia",
      "es": "Mongolia"
    },
    "order": 116,
    "is_active": false,
    "metadata": {
      "alpha3": "MNG",
      "numeric": "496",
      "phone_prefix": "+976",
      "flag": "🇲🇳",
      "region": "asia"
    }
  },
  {
    "code": "MR",
    "label": {
      "en": "Mauritania",
      "es": "Mauritania"
    },
    "order": 117,
    "is_active": false,
    "metadata": {
      "alpha3": "MRT",
      "numeric": "478",
      "phone_prefix": "+222",
      "flag": "🇲🇷",
      "region": "africa"
    }
  },
  {
    "code": "MT",
    "label": {
      "en": "Malta",
      "es": "Malta"
    },
    "order": 118,
    "is_active": false,
    "metadata": {
      "alpha3": "MLT",
      "numeric": "470",
      "phone_prefix": "+356",
      "flag": "🇲🇹",
      "region": "europe"
    }
  },
  {
    "code": "MU",
    "label": {
      "en": "Mauritius",
      "es": "Mauricio"
    },
    "order": 119,
    "is_active": false,
    "metadata": {
      "alpha3": "MUS",
      "numeric": "480",
      "phone_prefix": "+230",
      "flag": "🇲🇺",
      "region": "africa"
    }
  },
  {
    "code": "MV",
    "label": {
      "en": "Maldives",
      "es": "Maldivas"
    },
    "order": 120,
    "is_active": false,
    "metadata": {
      "alpha3": "MDV",
      "numeric": "462",
      "phone_prefix": "+960",
      "flag": "🇲🇻",
      "region": "asia"
    }
  },
  {
    "code": "MW",
    "label": {
      "en": "Malawi",
      "es": "Malaui"
    },
    "order": 121,
    "is_active": false,
    "metadata": {
      "alpha3": "MWI",
      "numeric": "454",
      "phone_prefix": "+265",
      "flag": "🇲🇼",
      "region": "africa"
    }
  },
  {
    "code": "MX",
    "label": {
      "en": "Mexico",
      "es": "México"
    },
    "order": 122,
    "is_active": false,
    "metadata": {
      "alpha3": "MEX",
      "numeric": "484",
      "phone_prefix": "+52",
      "flag": "🇲🇽",
      "region": "americas"
    }
  },
  {
    "code": "MY",
    "label": {
      "en": "Malaysia",
      "es": "Malasia"
    },
    "order": 123,
    "is_active": false,
    "metadata": {
      "alpha3": "MYS",
      "numeric": "458",
      "phone_prefix": "+60",
      "flag": "🇲🇾",
      "region": "asia"
    }
  },
  {
    "code": "MZ",
    "label": {
      "en": "Mozambique",
      "es": "Mozambique"
    },
    "order": 124,
    "is_active": false,
    "metadata": {
      "alpha3": "MOZ",
      "numeric": "508",
      "phone_prefix": "+258",
      "flag": "🇲🇿",
      "region": "africa"
    }
  },
  {
    "code": "NA",
    "label": {
      "en": "Namibia",
      "es": "Namibia"
    },
    "order": 125,
    "is_active": false,
    "metadata": {
      "alpha3": "NAM",
      "numeric": "516",
      "phone_prefix": "+264",
      "flag": "🇳🇦",
      "region": "africa"
    }
  },
  {
    "code": "NE",
    "label": {
      "en": "Niger",
      "es": "Níger"
    },
    "order": 126,
    "is_active": false,
    "metadata": {
      "alpha3": "NER",
      "numeric": "562",
      "phone_prefix": "+227",
      "flag": "🇳🇪",
      "region": "africa"
    }
  },
  {
    "code": "NG",
    "label": {
      "en": "Nigeria",
      "es": "Nigeria"
    },
    "order": 127,
    "is_active": false,
    "metadata": {
      "alpha3": "NGA",
      "numeric": "566",
      "phone_prefix": "+234",
      "flag": "🇳🇬",
      "region": "africa"
    }
  },
  {
    "code": "NI",
    "label": {
      "en": "Nicaragua",
      "es": "Nicaragua"
    },
    "order": 128,
    "is_active": false,
    "metadata": {
      "alpha3": "NIC",
      "numeric": "558",
      "phone_prefix": "+505",
      "flag": "🇳🇮",
      "region": "americas"
    }
  },
  {
    "code": "NL",
    "label": {
      "en": "Netherlands",
      "es": "Países Bajos"
    },
    "order": 129,
    "is_active": false,
    "metadata": {
      "alpha3": "NLD",
      "numeric": "528",
      "phone_prefix": "+31",
      "flag": "🇳🇱",
      "region": "europe"
    }
  },
  {
    "code": "NO",
    "label": {
      "en": "Norway",
      "es": "Noruega"
    },
    "order": 130,
    "is_active": false,
    "metadata": {
      "alpha3": "NOR",
      "numeric": "578",
      "phone_prefix": "+47",
      "flag": "🇳🇴",
      "region": "europe"
    }
  },
  {
    "code": "NP",
    "label": {
      "en": "Nepal",
      "es": "Nepal"
    },
    "order": 131,
    "is_active": false,
    "metadata": {
      "alpha3": "NPL",
      "numeric": "524",
      "phone_prefix": "+977",
      "flag": "🇳🇵",
      "region": "asia"
    }
  },
  {
    "code": "NR",
    "label": {
      "en": "Nauru",
      "es": "Nauru"
    },
    "order": 132,
    "is_active": false,
    "metadata": {
      "alpha3": "NRU",
      "numeric": "520",
      "phone_prefix": "+674",
      "flag": "🇳🇷",
      "region": "oceania"
    }
  },
  {
    "code": "NZ",
    "label": {
      "en": "New Zealand",
      "es": "Nueva Zelanda"
    },
    "order": 133,
    "is_active": false,
    "metadata": {
      "alpha3": "NZL",
      "numeric": "554",
      "phone_prefix": "+64",
      "flag": "🇳🇿",
      "region": "oceania"
    }
  },
  {
    "code": "OM",
    "label": {
      "en": "Oman",
      "es": "Omán"
    },
    "order": 134,
    "is_active": false,
    "metadata": {
      "alpha3": "OMN",
      "numeric": "512",
      "phone_prefix": "+968",
      "flag": "🇴🇲",
      "region": "asia"
    }
  },
  {
    "code": "PA",
    "label": {
      "en": "Panama",
      "es": "Panamá"
    },
    "order": 135,
    "is_active": false,
    "metadata": {
      "alpha3": "PAN",
      "numeric": "591",
      "phone_prefix": "+507",
      "flag": "🇵🇦",
      "region": "americas"
    }
  },
  {
    "code": "PE",
    "label": {
      "en": "Peru",
      "es": "Perú"
    },
    "order": 136,
    "is_active": false,
    "metadata": {
      "alpha3": "PER",
      "numeric": "604",
      "phone_prefix": "+51",
      "flag": "🇵🇪",
      "region": "americas"
    }
  },
  {
    "code": "PG",
    "label": {
      "en": "Papua New Guinea",
      "es": "Papúa Nueva Guinea"
    },
    "order": 137,
    "is_active": false,
    "metadata": {
      "alpha3": "PNG",
      "numeric": "598",
      "phone_prefix": "+675",
      "flag": "🇵🇬",
      "region": "oceania"
    }
  },
  {
    "code": "PH",
    "label": {
      "en": "Philippines",
      "es": "Filipinas"
    },
    "order": 138,
    "is_active": false,
    "metadata": {
      "alpha3": "PHL",
      "numeric": "608",
      "phone_prefix": "+63",
      "flag": "🇵🇭",
      "region": "asia"
    }
  },
  {
    "code": "PK",
    "label": {
      "en": "Pakistan",
      "es": "Pakistán"
    },
    "order": 139,
    "is_active": false,
    "metadata": {
      "alpha3": "PAK",
      "numeric": "586",
      "phone_prefix": "+92",
      "flag": "🇵🇰",
      "region": "asia"
    }
  },
  {
    "code": "PL",
    "label": {
      "en": "Poland",
      "es": "Polonia"
    },
    "order": 140,
    "is_active": false,
    "metadata": {
      "alpha3": "POL",
      "numeric": "616",
      "phone_prefix": "+48",
      "flag": "🇵🇱",
      "region": "europe"
    }
  },
  {
    "code": "PT",
    "label": {
      "en": "Portugal",
      "es": "Portugal"
    },
    "order": 141,
    "is_active": false,
    "metadata": {
      "alpha3": "PRT",
      "numeric": "620",
      "phone_prefix": "+351",
      "flag": "🇵🇹",
      "region": "europe"
    }
  },
  {
    "code": "PW",
    "label": {
      "en": "Palau",
      "es": "Palaos"
    },
    "order": 142,
    "is_active": false,
    "metadata": {
      "alpha3": "PLW",
      "numeric": "585",
      "phone_prefix": "+680",
      "flag": "🇵🇼",
      "region": "oceania"
    }
  },
  {
    "code": "PY",
    "label": {
      "en": "Paraguay",
      "es": "Paraguay"
    },
    "order": 143,
    "is_active": false,
    "metadata": {
      "alpha3": "PRY",
      "numeric": "600",
      "phone_prefix": "+595",
      "flag": "🇵🇾",
      "region": "americas"
    }
  },
  {
    "code": "QA",
    "label": {
      "en": "Qatar",
      "es": "Catar"
    },
    "order": 144,
    "is_active": false,
    "metadata": {
      "alpha3": "QAT",
      "numeric": "634",
      "phone_prefix": "+974",
      "flag": "🇶🇦",
      "region": "asia"
    }
  },
  {
    "code": "RO",
    "label": {
      "en": "Romania",
      "es": "Rumanía"
    },
    "order": 145,
    "is_active": false,
    "metadata": {
      "alpha3": "ROU",
      "numeric": "642",
      "phone_prefix": "+40",
      "flag": "🇷🇴",
      "region": "europe"
    }
  },
  {
    "code": "RS",
    "label": {
      "en": "Serbia",
      "es": "Serbia"
    },
    "order": 146,
    "is_active": false,
    "metadata": {
      "alpha3": "SRB",
      "numeric": "688",
      "phone_prefix": "+381",
      "flag": "🇷🇸",
      "region": "europe"
    }
  },
  {
    "code": "RU",
    "label": {
      "en": "Russia",
      "es": "Rusia"
    },
    "order": 147,
    "is_active": false,
    "metadata": {
      "alpha3": "RUS",
      "numeric": "643",
      "phone_prefix": "+7",
      "flag": "🇷🇺",
      "region": "europe"
    }
  },
  {
    "code": "RW",
    "label": {
      "en": "Rwanda",
      "es": "Ruanda"
    },
    "order": 148,
    "is_active": false,
    "metadata": {
      "alpha3": "RWA",
      "numeric": "646",
      "phone_prefix": "+250",
      "flag": "🇷🇼",
      "region": "africa"
    }
  },
  {
    "code": "SA",
    "label": {
      "en": "Saudi Arabia",
      "es": "Arabia Saudita"
    },
    "order": 149,
    "is_active": false,
    "metadata": {
      "alpha3": "SAU",
      "numeric": "682",
      "phone_prefix": "+966",
      "flag": "🇸🇦",
      "region": "asia"
    }
  },
  {
    "code": "SB",
    "label": {
      "en": "Solomon Islands",
      "es": "Islas Salomón"
    },
    "order": 150,
    "is_active": false,
    "metadata": {
      "alpha3": "SLB",
      "numeric": "090",
      "phone_prefix": "+677",
      "flag": "🇸🇧",
      "region": "oceania"
    }
  },
  {
    "code": "SC",
    "label": {
      "en": "Seychelles",
      "es": "Seychelles"
    },
    "order": 151,
    "is_active": false,
    "metadata": {
      "alpha3": "SYC",
      "numeric": "690",
      "phone_prefix": "+248",
      "flag": "🇸🇨",
      "region": "africa"
    }
  },
  {
    "code": "SD",
    "label": {
      "en": "Sudan",
      "es": "Sudán"
    },
    "order": 152,
    "is_active": false,
    "metadata": {
      "alpha3": "SDN",
      "numeric": "729",
      "phone_prefix": "+249",
      "flag": "🇸🇩",
      "region": "africa"
    }
  },
  {
    "code": "SE",
    "label": {
      "en": "Sweden",
      "es": "Suecia"
    },
    "order": 153,
    "is_active": false,
    "metadata": {
      "alpha3": "SWE",
      "numeric": "752",
      "phone_prefix": "+46",
      "flag": "🇸🇪",
      "region": "europe"
    }
  },
  {
    "code": "SG",
    "label": {
      "en": "Singapore",
      "es": "Singapur"
    },
    "order": 154,
    "is_active": false,
    "metadata": {
      "alpha3": "SGP",
      "numeric": "702",
      "phone_prefix": "+65",
      "flag": "🇸🇬",
      "region": "asia"
    }
  },
  {
    "code": "SI",
    "label": {
      "en": "Slovenia",
      "es": "Eslovenia"
    },
    "order": 155,
    "is_active": false,
    "metadata": {
      "alpha3": "SVN",
      "numeric": "705",
      "phone_prefix": "+386",
      "flag": "🇸🇮",
      "region": "europe"
    }
  },
  {
    "code": "SK",
    "label": {
      "en": "Slovakia",
      "es": "Eslovaquia"
    },
    "order": 156,
    "is_active": false,
    "metadata": {
      "alpha3": "SVK",
      "numeric": "703",
      "phone_prefix": "+421",
      "flag": "🇸🇰",
      "region": "europe"
    }
  },
  {
    "code": "SL",
    "label": {
      "en": "Sierra Leone",
      "es": "Sierra Leona"
    },
    "order": 157,
    "is_active": false,
    "metadata": {
      "alpha3": "SLE",
      "numeric": "694",
      "phone_prefix": "+232",
      "flag": "🇸🇱",
      "region": "africa"
    }
  },
  {
    "code": "SM",
    "label": {
      "en": "San Marino",
      "es": "San Marino"
    },
    "order": 158,
    "is_active": false,
    "metadata": {
      "alpha3": "SMR",
      "numeric": "674",
      "phone_prefix": "+378",
      "flag": "🇸🇲",
      "region": "europe"
    }
  },
  {
    "code": "SN",
    "label": {
      "en": "Senegal",
      "es": "Senegal"
    },
    "order": 159,
    "is_active": false,
    "metadata": {
      "alpha3": "SEN",
      "numeric": "686",
      "phone_prefix": "+221",
      "flag": "🇸🇳",
      "region": "africa"
    }
  },
  {
    "code": "SO",
    "label": {
      "en": "Somalia",
      "es": "Somalia"
    },
    "order": 160,
    "is_active": false,
    "metadata": {
      "alpha3": "SOM",
      "numeric": "706",
      "phone_prefix": "+252",
      "flag": "🇸🇴",
      "region": "africa"
    }
  },
  {
    "code": "SR",
    "label": {
      "en": "Suriname",
      "es": "Surinam"
    },
    "order": 161,
    "is_active": false,
    "metadata": {
      "alpha3": "SUR",
      "numeric": "740",
      "phone_prefix": "+597",
      "flag": "🇸🇷",
      "region": "americas"
    }
  },
  {
    "code": "SS",
    "label": {
      "en": "South Sudan",
      "es": "Sudán del Sur"
    },
    "order": 162,
    "is_active": false,
    "metadata": {
      "alpha3": "SSD",
      "numeric": "728",
      "phone_prefix": "+211",
      "flag": "🇸🇸",
      "region": "africa"
    }
  },
  {
    "code": "ST",
    "label": {
      "en": "Sao Tome and Principe",
      "es": "Santo Tomé y Príncipe"
    },
    "order": 163,
    "is_active": false,
    "metadata": {
      "alpha3": "STP",
      "numeric": "678",
      "phone_prefix": "+239",
      "flag": "🇸🇹",
      "region": "africa"
    }
  },
  {
    "code": "SV",
    "label": {
      "en": "El Salvador",
      "es": "El Salvador"
    },
    "order": 164,
    "is_active": false,
    "metadata": {
      "alpha3": "SLV",
      "numeric": "222",
      "phone_prefix": "+503",
      "flag": "🇸🇻",
      "region": "americas"
    }
  },
  {
    "code": "SY",
    "label": {
      "en": "Syria",
      "es": "Siria"
    },
    "order": 165,
    "is_active": false,
    "metadata": {
      "alpha3": "SYR",
      "numeric": "760",
      "phone_prefix": "+963",
      "flag": "🇸🇾",
      "region": "asia"
    }
  },
  {
    "code": "SZ",
    "label": {
      "en": "Eswatini",
      "es": "Esuatini"
    },
    "order": 166,
    "is_active": false,
    "metadata": {
      "alpha3": "SWZ",
      "numeric": "748",
      "phone_prefix": "+268",
      "flag": "🇸🇿",
      "region": "africa"
    }
  },
  {
    "code": "TD",
    "label": {
      "en": "Chad",
      "es": "Chad"
    },
    "order": 167,
    "is_active": false,
    "metadata": {
      "alpha3": "TCD",
      "numeric": "148",
      "phone_prefix": "+235",
      "flag": "🇹🇩",
      "region": "africa"
    }
  },
  {
    "code": "TG",
    "label": {
      "en": "Togo",
      "es": "Togo"
    },
    "order": 168,
    "is_active": false,
    "metadata": {
      "alpha3": "TGO",
      "numeric": "768",
      "phone_prefix": "+228",
      "flag": "🇹🇬",
      "region": "africa"
    }
  },
  {
    "code": "TH",
    "label": {
      "en": "Thailand",
      "es": "Tailandia"
    },
    "order": 169,
    "is_active": false,
    "metadata": {
      "alpha3": "THA",
      "numeric": "764",
      "phone_prefix": "+66",
      "flag": "🇹🇭",
      "region": "asia"
    }
  },
  {
    "code": "TJ",
    "label": {
      "en": "Tajikistan",
      "es": "Tayikistán"
    },
    "order": 170,
    "is_active": false,
    "metadata": {
      "alpha3": "TJK",
      "numeric": "762",
      "phone_prefix": "+992",
      "flag": "🇹🇯",
      "region": "asia"
    }
  },
  {
    "code": "TL",
    "label": {
      "en": "Timor-Leste",
      "es": "Timor Oriental"
    },
    "order": 171,
    "is_active": false,
    "metadata": {
      "alpha3": "TLS",
      "numeric": "626",
      "phone_prefix": "+670",
      "flag": "🇹🇱",
      "region": "asia"
    }
  },
  {
    "code": "TM",
    "label": {
      "en": "Turkmenistan",
      "es": "Turkmenistán"
    },
    "order": 172,
    "is_active": false,
    "metadata": {
      "alpha3": "TKM",
      "numeric": "795",
      "phone_prefix": "+993",
      "flag": "🇹🇲",
      "region": "asia"
    }
  },
  {
    "code": "TN",
    "label": {
      "en": "Tunisia",
      "es": "Túnez"
    },
    "order": 173,
    "is_active": false,
    "metadata": {
      "alpha3": "TUN",
      "numeric": "788",
      "phone_prefix": "+216",
      "flag": "🇹🇳",
      "region": "africa"
    }
  },
  {
    "code": "TO",
    "label": {
      "en": "Tonga",
      "es": "Tonga"
    },
    "order": 174,
    "is_active": false,
    "metadata": {
      "alpha3": "TON",
      "numeric": "776",
      "phone_prefix": "+676",
      "flag": "🇹🇴",
      "region": "oceania"
    }
  },
  {
    "code": "TR",
    "label": {
      "en": "Turkey",
      "es": "Turquía"
    },
    "order": 175,
    "is_active": false,
    "metadata": {
      "alpha3": "TUR",
      "numeric": "792",
      "phone_prefix": "+90",
      "flag": "🇹🇷",
      "region": "asia"
    }
  },
  {
    "code": "TT",
    "label": {
      "en": "Trinidad and Tobago",
      "es": "Trinidad y Tobago"
    },
    "order": 176,
    "is_active": false,
    "metadata": {
      "alpha3": "TTO",
      "numeric": "780",
      "phone_prefix": "+1-868",
      "flag": "🇹🇹",
      "region": "americas"
    }
  },
  {
    "code": "TV",
    "label": {
      "en": "Tuvalu",
      "es": "Tuvalu"
    },
    "order": 177,
    "is_active": false,
    "metadata": {
      "alpha3": "TUV",
      "numeric": "798",
      "phone_prefix": "+688",
      "flag": "🇹🇻",
      "region": "oceania"
    }
  },
  {
    "code": "TZ",
    "label": {
      "en": "Tanzania",
      "es": "Tanzania"
    },
    "order": 178,
    "is_active": false,
    "metadata": {
      "alpha3": "TZA",
      "numeric": "834",
      "phone_prefix": "+255",
      "flag": "🇹🇿",
      "region": "africa"
    }
  },
  {
    "code": "UA",
    "label": {
      "en": "Ukraine",
      "es": "Ucrania"
    },
    "order": 179,
    "is_active": false,
    "metadata": {
      "alpha3": "UKR",
      "numeric": "804",
      "phone_prefix": "+380",
      "flag": "🇺🇦",
      "region": "europe"
    }
  },
  {
    "code": "UG",
    "label": {
      "en": "Uganda",
      "es": "Uganda"
    },
    "order": 180,
    "is_active": false,
    "metadata": {
      "alpha3": "UGA",
      "numeric": "800",
      "phone_prefix": "+256",
      "flag": "🇺🇬",
      "region": "africa"
    }
  },
  {
    "code": "US",
    "label": {
      "en": "United States",
      "es": "Estados Unidos"
    },
    "order": 181,
    "is_active": false,
    "metadata": {
      "alpha3": "USA",
      "numeric": "840",
      "phone_prefix": "+1",
      "flag": "🇺🇸",
      "region": "americas"
    }
  },
  {
    "code": "UY",
    "label": {
      "en": "Uruguay",
      "es": "Uruguay"
    },
    "order": 182,
    "is_active": false,
    "metadata": {
      "alpha3": "URY",
      "numeric": "858",
      "phone_prefix": "+598",
      "flag": "🇺🇾",
      "region": "americas"
    }
  },
  {
    "code": "UZ",
    "label": {
      "en": "Uzbekistan",
      "es": "Uzbekistán"
    },
    "order": 183,
    "is_active": false,
    "metadata": {
      "alpha3": "UZB",
      "numeric": "860",
      "phone_prefix": "+998",
      "flag": "🇺🇿",
      "region": "asia"
    }
  },
  {
    "code": "VA",
    "label": {
      "en": "Vatican City",
      "es": "Ciudad del Vaticano"
    },
    "order": 184,
    "is_active": false,
    "metadata": {
      "alpha3": "VAT",
      "numeric": "336",
      "phone_prefix": "+379",
      "flag": "🇻🇦",
      "region": "europe"
    }
  },
  {
    "code": "VC",
    "label": {
      "en": "Saint Vincent and the Grenadines",
      "es": "San Vicente y las Granadinas"
    },
    "order": 185,
    "is_active": false,
    "metadata": {
      "alpha3": "VCT",
      "numeric": "670",
      "phone_prefix": "+1-784",
      "flag": "🇻🇨",
      "region": "americas"
    }
  },
  {
    "code": "VE",
    "label": {
      "en": "Venezuela",
      "es": "Venezuela"
    },
    "order": 186,
    "is_active": false,
    "metadata": {
      "alpha3": "VEN",
      "numeric": "862",
      "phone_prefix": "+58",
      "flag": "🇻🇪",
      "region": "americas"
    }
  },
  {
    "code": "VN",
    "label": {
      "en": "Vietnam",
      "es": "Vietnam"
    },
    "order": 187,
    "is_active": false,
    "metadata": {
      "alpha3": "VNM",
      "numeric": "704",
      "phone_prefix": "+84",
      "flag": "🇻🇳",
      "region": "asia"
    }
  },
  {
    "code": "VU",
    "label": {
      "en": "Vanuatu",
      "es": "Vanuatu"
    },
    "order": 188,
    "is_active": false,
    "metadata": {
      "alpha3": "VUT",
      "numeric": "548",
      "phone_prefix": "+678",
      "flag": "🇻🇺",
      "region": "oceania"
    }
  },
  {
    "code": "WS",
    "label": {
      "en": "Samoa",
      "es": "Samoa"
    },
    "order": 189,
    "is_active": false,
    "metadata": {
      "alpha3": "WSM",
      "numeric": "882",
      "phone_prefix": "+685",
      "flag": "🇼🇸",
      "region": "oceania"
    }
  },
  {
    "code": "XK",
    "label": {
      "en": "Kosovo",
      "es": "Kosovo"
    },
    "order": 190,
    "is_active": false,
    "metadata": {
      "alpha3": "XKX",
      "numeric": "383",
      "phone_prefix": "+383",
      "flag": "🇽🇰",
      "region": "europe"
    }
  },
  {
    "code": "YE",
    "label": {
      "en": "Yemen",
      "es": "Yemen"
    },
    "order": 191,
    "is_active": false,
    "metadata": {
      "alpha3": "YEM",
      "numeric": "887",
      "phone_prefix": "+967",
      "flag": "🇾🇪",
      "region": "asia"
    }
  },
  {
    "code": "ZA",
    "label": {
      "en": "South Africa",
      "es": "Sudáfrica"
    },
    "order": 192,
    "is_active": false,
    "metadata": {
      "alpha3": "ZAF",
      "numeric": "710",
      "phone_prefix": "+27",
      "flag": "🇿🇦",
      "region": "africa"
    }
  },
  {
    "code": "ZM",
    "label": {
      "en": "Zambia",
      "es": "Zambia"
    },
    "order": 193,
    "is_active": false,
    "metadata": {
      "alpha3": "ZMB",
      "numeric": "894",
      "phone_prefix": "+260",
      "flag": "🇿🇲",
      "region": "africa"
    }
  },
  {
    "code": "ZW",
    "label": {
      "en": "Zimbabwe",
      "es": "Zimbabue"
    },
    "order": 194,
    "is_active": false,
    "metadata": {
      "alpha3": "ZWE",
      "numeric": "716",
      "phone_prefix": "+263",
      "flag": "🇿🇼",
      "region": "africa"
    }
  }
]
